import { Typography } from '@mui/material'
import type { FC, HTMLAttributeAnchorTarget, PropsWithChildren } from 'react'

interface LinkTransProps extends PropsWithChildren {
  color?: string
  href: string
  rel?: string
  target?: HTMLAttributeAnchorTarget
}

// Note: Use this wrapper when you need to format a link inside <Trans /> component
export const LinkTrans: FC<LinkTransProps> = ({ children, color, rel, target, href }) => {
  return (
    <Typography component='a' target={target} rel={rel} href={href} role='link' variant='textLinkM' color={color}>
      {children}
    </Typography>
  )
}
